<template>
<div class="w-1/5 mb-5 p-2">
    <div class="search-wrapper">
       <input class="input-black" type="text" placeholder="Search object...">
       <i class="search"></i>
    </div>

    <ul class="categories">
        <li v-for="cat in categories" :class="{'active': cat.fileType == fileType}">
            <div class="flex justify-between cursor-pointer">
                <div class="flex icon-name items-center">
                    <i :class="cat.icon"></i>
                    <span>{{ cat.name }}</span>
                </div>
                <span class="number-wrapper">
                    <span class="number">{{ cat.count }}</span>
                </span>
            </div>
        </li>
    </ul>

</div>
</template>

<script>

export default {
    props: {
        locale: String,
        fileType: String,
    },
    methods:{
        getCount(fileType){
            let files = this.$page.props.files.data.filter(el => !el.path.includes('one'))
            files = files.filter(el => !el.path.includes('two'));
            let count;
            if(fileType == 'all'){
                count = files.length;
            } else {
                count = files.filter(el => el.object_type.includes(fileType)).length
            }
            return count;
        }
    },
    data() {
        return {
            show: false,
            categories: [
                {
                    name: 'All',
                    icon: 'ricon-rooms',
                    count: this.getCount('all'),
                    fileType: 'all',
                },
                {
                    name: 'Images',
                    icon: 'images',
                    count: this.getCount('image'),
                    fileType: 'image',
                },
                {
                    name: 'Audio',
                    icon: 'ricon-headphone-sm',
                    count: this.getCount('audio'),
                    fileType: 'audio',
                },
                {
                    name: 'Video',
                    icon: 'ricon-video-sm',
                    count: this.getCount('video'),
                    fileType: 'video',
                },
                {
                    name: 'Panorama-Image',
                    icon: 'ricon-room360-sm',
                    count: this.getCount('panorama_image'),
                    fileType: 'panorama_image',
                },
                {
                    name: 'Panorama-Video',
                    icon: 'ricon-room360-sm',
                    count: this.getCount('panorama_video'),
                    fileType: 'panorama_video',
                },
                {
                    name: 'Chromavideo',
                    icon: 'ricon-video-sm',
                    count: this.getCount('chroma_video'),
                    fileType: 'chroma_video',
                },
                {
                    name: '3D Model',
                    icon: 'ricon-gyro',
                    count: this.getCount('three_dimensional_object'),
                    fileType: 'three_dimensional_object',
                },
                {
                    name: 'Marker',
                    icon: 'ricon-qr-code',
                    count: this.getCount('marker'),
                    fileType: 'marker',
                }
            ]
        }
    }
}
</script>
